/**
 * Starter objectives offered when creating a strategy. Deliberately plain,
 * business-language goals rather than strategy jargon: the point of asking is to
 * get the operator's actual intent in their own words, and a list of "increase
 * share of voice"-style phrasing would only teach them to answer in ours. The
 * agent sharpens whichever answer it gets into a measurable objective.
 *
 * Suggestions only — the field accepts anything typed.
 */
export const STARTER_OBJECTIVES = [
  "More sales",
  "Go viral on Instagram",
  "Grow our following",
  "Get people talking about us",
  "Build brand awareness",
  "Drive traffic to our website",
  "Generate more leads",
  "Launch a new product",
  "Get more engagement on our posts",
  "Reach a younger audience",
  "Become the go-to name in our category",
  "Turn our customers into a community",
  "Bring more people into our stores",
  "Be seen as the experts in our field",
  "Post consistently again",
  "Break into a new market",
];

export const OBJECTIVE_MAX_LENGTH = 200;
